import { type ApolloError, useQuery } from '@apollo/client';
import type { UseDealPromptRegionOptions } from '@openx/components-deal-prompt/lib/utils/types';
import type { Option } from '@openx/types/options';
import { useMemo } from 'react';
import {
  GetAvailableRegionsDocument,
  type GetAvailableRegionsQuery,
} from '../../../graphql/fragment/audiences/GetAvailableRegions.generated';

export const useDealPromptRegionOptions = (skip?: boolean): ReturnType<UseDealPromptRegionOptions> => {
  const { data, loading, error } = useQuery<GetAvailableRegionsQuery>(GetAvailableRegionsDocument, {
    skip,
    variables: {
      filter: { used: true },
    },
  });

  const regionOptions = useMemo<Option[]>(
    () =>
      (data?.optionsByPath ?? [])
        .filter((region): region is NonNullable<typeof region> => region !== null)
        .map(region => ({
          id: region.id,
          name: region.name,
        })),
    [data?.optionsByPath]
  );

  return {
    loading,
    error: error as ApolloError | undefined,
    data: regionOptions,
  };
};
